import axios from '../../../axiosConfig';

export async function createAssetEmployeeHistory(assetId, data, config = {}) {
    return await axios.post(`/v1/asset/${assetId}/employee-history`, data, config);
}

export async function createAssetLocationHistory(assetId, data, config = {}) {
    return await axios.post(`/v1/asset/${assetId}/location-history`, data, config);
}

export async function updateAssetEmployeeHistory(id, data, config = {}) {
    return await axios.put(`/v1/asset/employee-history/${id}`, data, config);
}

export async function updateAssetLocationHistory(id, data, config = {}) {
    return await axios.put(`/v1/asset/location-history/${id}`, data, config);
}

export async function deleteEmployeeHistory(id, config = {}) {
    return await axios.delete(`/v1/asset/employee-history/${id}`, config);
}

export async function deleteLocationHistory(id, config = {}) {
    return await axios.delete(`/v1/asset/location-history/${id}`, config);
}

const functions = { createAssetEmployeeHistory, createAssetLocationHistory, updateAssetEmployeeHistory, updateAssetLocationHistory, deleteEmployeeHistory, deleteLocationHistory }
export default functions
